import { z } from 'zod/v4';

export const representativeSchema = z.object({
  name: z.string().min(1, 'representatives.validation.nameRequired'),
  phone: z.string().default(''),
  email: z.string().refine((v) => v === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), {
    message: 'representatives.validation.emailInvalid',
  }).default(''),
  notes: z.string().default(''),
  commissionRate: z
    .number({ error: 'representatives.validation.commissionRateInvalid' })
    .min(0, 'representatives.validation.commissionRateRange')
    .max(100, 'representatives.validation.commissionRateRange')
    .default(0),
});

export type RepresentativeFormData = z.infer<typeof representativeSchema>;
